import { inject, Injectable } from '@angular/core';
import { JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import {
  Order,
  BackendRerouteService,
  SelectedCustomerService,
  CustomerService,
  OrderToBasketService,
  PriceConfigService,
  Customer,
  PdfDownloadIndicatorService,
  BackendInterceptor
} from 'gung-standard';
import { ActionButton } from 'gung-common';
import { Observable, of } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { first, switchMap } from 'rxjs';
import { ColmecOrderService } from './colmec-order.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ColmecJeevesOrderActionConfigService extends JeevesOrderActionConfigService {
  private orderService = inject(ColmecOrderService);
  private priceConfigService = inject(PriceConfigService);
  
  base = [
    { title: 'XLSX', action: (item: Order) => this.backendRerouteService.reroute('download/order-excel/' + item.id) },
    { title: 'PDF', action: (item: Order) => this.backendRerouteService.reroute('download/order-pdf/' + item.id) },
    {
      title: 'QUOTE_TO_ORDER',
      action: (item: Order) => {
        const updateOrder = JSON.parse(JSON.stringify(item));
        updateOrder.extra.oh = {
          ordstat: 10
        };
        this.orderService.updateOrderHeader(updateOrder).subscribe(order => {
          this.http
            .post('/json/order/send-confirmation', {
              emailRecipients: [environment.quoteConfirmationEmailAddress],
              orderId: order.id
            })
            .subscribe(() => {
              this.router.navigate(['/orders/' + order.id]);
              this.orderService.getQuotes(true).pipe(first()).subscribe();
              this.orderService.getOpenOrders(true).pipe(first()).subscribe();
            });
        });
      }
    },
    {
      title: 'CANCEL_QUOTE',
      action: (item: Order) => {
        const updateOrder = JSON.parse(JSON.stringify(item));
        updateOrder.extra.oh = {
          ordstat: 90
        };
        this.orderService.updateOrderHeader(updateOrder).subscribe(order => {
          this.orderService.updateQuotesSubject();
        });
      }
    }
  ];
  modalRef: NgbModalRef;

  getButtons(item: Order): Observable<ActionButton<Order>[]> {
    return this.priceConfigService.hidePrice.pipe(
      switchMap(hidePrice => {
        if (hidePrice) {
          return of([]);
        }
        return new Observable<ActionButton<Order>[]>(subscriber => {
          subscriber.next(this.base);
          subscriber.complete();
        });
      })
    );
  }
}
